import { useIntl } from "react-intl";

import { DEFAULT_VALUES } from "@/libraries/web-framework";

const AssetDiscovery = () => {
    const intl = useIntl();

    const messages = {
        header: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.AssetDiscovery.header",
            defaultMessage: "Asset discovery"
        }),
        body: intl.formatMessage(
            {
                id: "JiraServiceManagementPricingPage.features.AssetDiscovery.body",
                defaultMessage:
                    "<p>Scan your network to discover and populate your asset and service repository. Detect infrastructure changes, identify shadow IT assets, and improve support.</p><p>The Assets Discovery Marketplace app is required but is free for Premium and Enterprise plans. The collected data is imported into Assets in Jira Service Management.</p>"
            },
            {
                ...DEFAULT_VALUES
            }
        ),
        link: intl.formatMessage(
            {
                id: "JiraServiceManagementPricingPage.features.AssetDiscovery.link",
                defaultMessage:
                    "<learnMore>Learn more</learnMore> about Assets Discovery."
            },
            {
                learnMore: (chunk: React.ReactNode) => (
                    <a
                        href="https://support.atlassian.com/jira-service-management-cloud/docs/discover-objects-in-your-environment-with-insight-discovery/"
                        data-event="clicked"
                        data-event-component="linkButton"
                        data-product-key="jiraServiceManagement"
                        data-label-english="Learn more"
                    >
                        {chunk}
                    </a>
                )
            }
        )
    };

    return (
        <>
            <h2>{messages.header}</h2>
            <>{messages.body}</>
            <p>{messages.link}</p>
        </>
    );
};

export default AssetDiscovery;
